import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getPatterns } from "@/lib/apiClient";
import { Reveal } from "@/components/Reveal";

export default function PatternsList() {
  const [patterns, setPatterns] = useState(null);

  useEffect(() => { getPatterns().then(setPatterns); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <p className="eyebrow text-ink/60">Evidence, not predictions</p>
      <h1 data-testid="patterns-title" className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl display-tight uppercase mt-3">Patterns we're seeing</h1>
      <p className="text-base sm:text-lg text-ink/70 mt-5 max-w-2xl leading-relaxed">
        Repeated changes emerging from real AI transformations around the world. Not what we think will happen —
        what we're actually seeing happen, across many different businesses.
      </p>

      {patterns === null ? (
        <div className="mt-10 text-ink/40">Loading…</div>
      ) : patterns.length === 0 ? (
        <div className="mt-10 border-2 border-ink p-12 text-center" data-testid="patterns-empty">
          <h3 className="font-display font-extrabold text-2xl">No published patterns yet.</h3>
          <p className="text-ink/60 mt-2 max-w-md mx-auto">Patterns appear here once enough real cases demonstrate the same underlying business change — and an editor has reviewed them.</p>
        </div>
      ) : (
        <div className="mt-10 grid md:grid-cols-2 gap-6" data-testid="patterns-grid">
          {patterns.map((p, i) => (
            <Reveal key={p.slug} delay={i * 80}>
              <Link to={`/pattern/${p.slug}`} data-testid={`pattern-card-${p.slug}`} className="group lift-card block border-2 border-ink p-6 bg-white hover:shadow-[8px_8px_0_0_#0A0A0C] h-full">
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="eyebrow bg-ink text-white px-2 py-1">{p.supporting_count} cases</span>
                  <span className="eyebrow bg-bryellow text-ink px-2 py-1">{(p.industries || []).length} industries</span>
                  <span className="eyebrow bg-brlime text-ink px-2 py-1">{(p.countries || []).length} countries</span>
                </div>
                <h2 className="font-display font-extrabold text-2xl sm:text-3xl leading-[1.05] tracking-tight uppercase group-hover:text-cobalt transition-colors">{p.name}</h2>
                <p className="text-ink/70 mt-3 leading-relaxed">{p.description}</p>
                <span className="mt-5 inline-flex items-center gap-1 font-bold text-sm">Explore Pattern <ArrowRight size={16} className="arrow-move" /></span>
              </Link>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
}
